export default __webpack_public_path__ + "static/media/2269_closed.da2bc6a5.jpg";